<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :label="label"
    :items="filteredItems"
    item-text="username"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :search-input.sync="search"
    clearable
  )
</template>

<script>
import { CRUDUsers } from '@/services/API/user';
import { mapGetters } from 'vuex';

export default {
  props: {
    value: { type: Number, default: null },
    label: { type: String, default: 'Выберите пользователей' },
  },
  data() {
    return {
      items: [],
      loading:false,
      search:'',
    };
  },
  computed: {
    ...mapGetters({
      'user':'auth/getUser',
    }),
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    filteredItems() {
      return this.items.filter(({ id }) => this.user.id !== id);
    },
  },
  watch: {
    search() {
      if (this.loading) return;
      this.loading = true;

      this.loadItems();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadItems();
    },
    async loadItems() {
      const params = {
        'search[username]':this.search,
      };
      this.loading = true;
      try {
        await CRUDUsers.getAll(params).then((response) => {
          this.items = response.data.data;
        });
      } catch (err) {
        this.$toast.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
